import styles from './Spacing.module.scss';

interface Props {
  size?: 'xsmal' | 'small' | 'medium' | 'large' | 'xlarge';
}

export function Spacing({ size = 'medium' }: Props) {
  return <div className={styles[`spacing-${size}`]} />;
}
